import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-existingpatient',
  templateUrl: './existingpatient.component.html',
  styleUrls: ['./existingpatient.component.css']
})
export class ExistingpatientComponent implements OnInit {
   title = "ExistingPatient Form"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/existingpatient/existingpatient.component.ts